<template>
    <div class="chat-message" :class="{ 'self': isSelf }">
        <div class="flex gap-3 items-center" :class="{ 'flex-row-reverse': !isSelf }">
            <div class="text-left flex-1">
                <p class="text-11">
                    {{ senderName }} {{ $dateFormat(message.created, 'dd.MM.yyyy HH:mm:ss') }}
                </p>
                <p class="text-14 chat-message-message">
                    {{ message.message }}
                </p>
            </div>
            <div class="profile-image" :title="senderName">
                <CIcon v-if="!senderImage"
                       name="account-circle"
                       height="40"
                       width="40"
                       color="#11BAB2"
                       fill/>
                <img v-else :src="senderImage" class="h-10 w-10 rounded-full border">
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { GroupChatMessageViewObject, UserViewObject } from '@/api';
import { userStore } from '@/core/store/user/user.store';

const props = defineProps<{ message: GroupChatMessageViewObject, usersMap: Map<string, UserViewObject>, guestName?: string | null }>();

const sender = computed(() => props.message.senderUserId ? props.usersMap.get(props.message.senderUserId) : undefined);
const isGuestMessage = computed(() => !props.message.senderUserId);
const isSelf = computed(() => {
    if (props.message.senderUserId && props.message.senderUserId === userStore.user.value?.id)
        return true;

    if (isGuestMessage.value && props.guestName && props.message.senderName === props.guestName)
        return true;

    return false;
});
const senderName = computed(() => {
    if (isSelf.value && isGuestMessage.value)
        return 'Dig';

    if (isGuestMessage.value)
        return props.message.senderName || 'Ukendt';

    return sender.value ? sender.value.fullName : 'Ukendt';
});
const senderImage = computed(() => sender.value?.profileImageUrl || null);
</script>

<style lang="scss" scoped>
.chat-message {
    max-width: 80%;
    &.self {
        margin-left: auto;
        border-top-left-radius: 0.75rem;
    }
    &:not(.self) {
        border-top-right-radius: 0.75rem;
    }
    background-color: theme('colors.background');
    border: 1px solid theme('colors.border');
    padding: 0.75rem;
    margin-bottom: 0.5rem;
}
.chat-message-message {
    overflow-wrap: anywhere;
}
.profile-image img {
    object-fit: cover;
}
</style>
